
export default {
  name: 'SectionFullwidthBackground',
  props: {
    bg: {
      default: 'secondary'
    },
    hidden: {
      default: false
    }
  }
}
